import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgBellOff(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M16.5858 18L20.2929 21.7071C20.6834 22.0977 21.3166 22.0977 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L3.70711 2.29292C3.31658 1.9024 2.68342 1.9024 2.29289 2.29292C1.90237 2.68345 1.90237 3.31661 2.29289 3.70714L5.36136 6.7756C5.12696 7.47517 4.99997 8.224 4.99997 9.00251L5 11.4977C5 12.4906 4.51657 13.9371 3.52529 15.792C3.00859 16.7589 3.72806 17.9998 4.84787 18H16.5858Z", fill: "currentColor" }),
        React.createElement("path", { d: "M20.4826 15.7976C20.623 16.063 20.6711 16.3448 20.6453 16.615L7.59245 3.56209C8.79579 2.58531 10.3295 2 12 2C15.866 2 19 5.13513 19 9.00251L19 11.4977C19 12.4639 19.4863 13.9142 20.4826 15.7976Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12 22C13.5386 22 14.8066 20.8413 14.9798 19.3487H9.02014C9.19333 20.8413 10.4614 22 12 22Z", fill: "currentColor" })));
}
export default SvgBellOff;
